import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './header';
import SidebarMenu from './sideBarComponent';
import Footer from './footer';
import {BackDropPageLoadingOverlay} from "./BackDropComponents";
import {NotificationContainer} from "react-notifications";

export default function PrivateLayout() {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <div className="flex flex-col h-full">
            <Header setIsLoading={setIsLoading} />
            <BackDropPageLoadingOverlay opened={isLoading} />

            <div className="flex flex-1 flex-row h-full overflow-y-auto">
                <SidebarMenu setIsLoading={setIsLoading} />

                <div className="flex flex-1 flex-col ml-5 mr-10 mt-8 flex-nowrap gap-y-3 h-full">
                    <Outlet context={{ isLoading, setIsLoading }} /> {/* This renders the child route */}
                    <Footer />
                </div>
            </div>
            <NotificationContainer />
        </div>
    );
}